import { createApi } from '@reduxjs/toolkit/query/react';
import { identity, pickBy } from 'lodash';

import { API_URL } from '../../../common/constants/api-url';
import {
  AuthorDto,
  GetAllAuthorsOptions,
  GetAuthorsResponse,
} from '../../../common/interfaces/authors-api';
import { getBaseQuery } from '../base-query';
import { UpdateAuthorImageReqBody, UpdateAuthorReqBody } from './authors-api-types';

export const authorsApiSlice = createApi({
  baseQuery: getBaseQuery({
    baseUrl: `${API_URL}/pages/authors`,
  }),
  endpoints: (builder) => ({
    createAuthor: builder.mutation<GetAuthorsResponse, Omit<AuthorDto, 'img' | 'created_at' | 'updated_at' | 'id'>>({
      query: (body) => ({
        body: pickBy(body, identity()),
        method: 'POST',
        url: '',
      })
    }),
    deleteAuthor: builder.mutation<null, number>({
      query: (id) => ({
        method: 'DELETE',
        url: `/${id}`,
      })
    }),
    getAuthorBuId: builder.mutation<AuthorDto, number>({
      query: (id) => ({
        method: 'GET',
        url: `/${id}`,
      })
    }),
    getAuthors: builder.query<GetAuthorsResponse, GetAllAuthorsOptions>({
      query: (params) => ({
        method: 'GET',
        params: { limit: 50, offset: 0, ...pickBy(params, identity()) },
        url: '/list',
      }),
    }),
    updateAuthor: builder.mutation<GetAuthorsResponse, UpdateAuthorReqBody>({
      query: ({ id, payload }) => ({
        body: pickBy(payload, identity()),
        method: 'PUT',
        url: `/${id}`,
      })
    }),
    updateAuthorImage: builder.mutation<null, UpdateAuthorImageReqBody>({
      query: ({ id, img }) => ({
        body: { img },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        method: 'POST',
        url: `/${id}`,
      })
    }),
  }),
  reducerPath: 'authors',
});
